import { useMemo } from 'react';

import type { SelectOptionT } from '@/components/Select/types';
import useAgentStore from '@/features/Agent/stores';
import useLocaleStore from '@/stores/LocaleStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';

const createOptionsFromValues = (values: string[]) => {
  return values.map((value) => ({
    value,
    searchName: value,
  }));
};

const useCustomerAttributes = () => {
  const workspaceFieldOptions = useWorkspaceStore(
    (state) => state.workspaceFieldOptions,
  );

  const regionMap = useLocaleStore((state) => state.regionMap);
  const agentMap = useAgentStore((state) => state.agentMap);

  const jobFunctionOptions: SelectOptionT[] = useMemo(() => {
    return createOptionsFromValues(workspaceFieldOptions.job_function_values);
  }, [workspaceFieldOptions.job_function_values]);

  const typeOptions: SelectOptionT[] = useMemo(() => {
    return createOptionsFromValues(workspaceFieldOptions.contact_type_values);
  }, [workspaceFieldOptions.contact_type_values]);

  const planOptions: SelectOptionT[] = useMemo(() => {
    return createOptionsFromValues(workspaceFieldOptions.contact_plan_values);
  }, [workspaceFieldOptions.contact_plan_values]);

  const stageOptions: SelectOptionT[] = useMemo(() => {
    return createOptionsFromValues(workspaceFieldOptions.contact_stage_values);
  }, [workspaceFieldOptions.contact_stage_values]);

  const countryOptions: SelectOptionT[] = useMemo(() => {
    return Object.keys(regionMap)
      .sort((a, b) => regionMap[a].country.localeCompare(regionMap[b].country))
      .map((key) => {
        return {
          value: key,
          searchName: regionMap[key].country,
        };
      });
  }, [regionMap]);

  const agentOptions: SelectOptionT[] = useMemo(() => {
    return Object.keys(agentMap).map((key) => {
      return {
        value: key,
        searchName: agentMap[key].name,
      };
    });
  }, [agentMap]);

  return {
    jobFunctionOptions,
    typeOptions,
    planOptions,
    countryOptions,
    agentOptions,
    stageOptions,
  };
};

export default useCustomerAttributes;
